import React from 'react';
import '../Footer.scss';
import { GeneralContext } from '../../../context/generalContext';
import ModalComponent from './ModalComponent';

function ModalAddresses({ showModal, setShowModal, addressesAll, footerCity, setFooterCity }) {
  const { cities, windowWidth, activeLanguage } = React.useContext(GeneralContext);

  // для автодокрутки
  const addressesRef = React.useRef();
  const citiesRef = React.useRef();
  const addressesMobileRef = React.useRef();
  const citiesMobileRef = React.useRef();
  React.useEffect(() => {
    if (addressesRef && footerCity) {
      const addresses = addressesRef.current?.children.namedItem(footerCity);
      const cities = citiesRef.current?.children.namedItem(footerCity);
      addresses?.scrollIntoView();
      cities?.scrollIntoView({ inline: 'center' });
    }
    if (addressesMobileRef && footerCity) {
      const addresses = addressesMobileRef.current?.children.namedItem(footerCity);
      const cities = citiesMobileRef.current?.children.namedItem(footerCity);
      addresses?.scrollIntoView();
      cities?.scrollIntoView({ inline: 'center' });
    }
  }, [footerCity]);

  return (
    <>
      {windowWidth > 770 ? (
        <ModalComponent showModal={showModal} setShowModal={setShowModal} maxWidth='700px' maxHeight='610px'>
          <div className='modal'>
            <div className='modal__title'>{activeLanguage === 1 ? 'Адреса' : 'Addresses'}</div>
            <div className='modal__cities' ref={citiesRef}>
              {cities.map(city => (
                <div
                  className={city.id === footerCity ? 'modal__cityTab modal__cityTab-active' : 'modal__cityTab'}
                  onClick={() => setFooterCity(city.id)}
                  key={city.id}
                  name={city.id}
                >
                  {activeLanguage === 1 ? city.footer_name || city.name : city.footer_name_en || city.name_en}
                </div>
              ))}
            </div>
            <div className='modal__wrapper' ref={addressesRef}>
              {cities.map(city => (
                <ul className='modal__address-block' key={city.id} name={city.id}>
                  <p className='modal__city'>
                    {activeLanguage === 1 ? city.footer_name || city.name : city.footer_name_en || city.name_en}
                  </p>
                  {addressesAll
                    .filter(item => item.cityId === city.id)
                    .map(address => (
                      <li className='modal__address' key={address.id}>
                        <a
                          href={activeLanguage === 1 ? address.subdomainLink : address.subdomainLink_en}
                          dangerouslySetInnerHTML={{
                            __html:
                              activeLanguage === 1
                                ? address.description
                                    ?.replace('Новосибирск, ', '')
                                    .replace(', Алтайский край', '')
                                    .replace('Алтайский край, ', '')
                                    .replace('Воронеж, ', '')
                                    .replace('Новокузнецк, ', '')
                                    .replace('Ташкент, ', '')
                                : address.description_en
                                    ?.replace('Novosibirsk, ', '')
                                    .replace('Voronezh, ', '')
                                    .replace('Novokuznetsk, ', '')
                                    .replace('Tashkent, ', '') ||
                                  address.description
                                    ?.replace('Новосибирск, ', '')
                                    .replace(', Алтайский край', '')
                                    .replace('Алтайский край, ', '')
                                    .replace('Воронеж, ', '')
                                    .replace('Новокузнецк, ', '')
                                    .replace('Ташкент, ', ''),
                          }}
                        />
                      </li>
                    ))}
                </ul>
              ))}
            </div>
          </div>
        </ModalComponent>
      ) : (
        <ModalComponent
          // targetRef={targetRef}
          showModal={showModal}
          setShowModal={setShowModal}
          maxWidth='100%'
          maxHeight='75%'
        >
          <div className='modal'>
            <div className='modal__title'>{activeLanguage === 1 ? 'Адреса ресторанов' : 'Addresses'}</div>
            <div className='modal__citiesMobile' ref={citiesMobileRef}>
              {cities.map(city => (
                <div
                  className={city.id === footerCity ? 'modal__cityTab modal__cityTab-active' : 'modal__cityTab'}
                  onClick={() => setFooterCity(city.id)}
                  key={city.id}
                  name={city.id}
                >
                  {activeLanguage === 1 ? city.footer_name || city.name : city.footer_name_en || city.name_en}
                </div>
              ))}
            </div>
            <ul className='modal__address-block' ref={addressesMobileRef}>
              {cities.map(city => (
                <div key={city.id} name={city.id} className='modal__cityDiv'>
                  <p className='modal__city'>
                    {activeLanguage === 1 ? city.footer_name || city.name : city.footer_name_en || city.name_en}
                  </p>
                  {addressesAll
                    .filter(item => item.cityId === city.id)
                    .map(address => (
                      <li className='modal__address' key={address.id}>
                        <a
                          href={activeLanguage === 1 ? address.subdomainLink : address.subdomainLink_en}
                          dangerouslySetInnerHTML={{
                            __html:
                              activeLanguage === 1
                                ? address.description
                                    ?.replace('Новосибирск, ', '')
                                    .replace(', Алтайский край', '')
                                    .replace('Алтайский край, ', '')
                                    .replace('Воронеж, ', '')
                                    .replace('Новокузнецк, ', '')
                                    .replace('Ташкент, ', '')
                                : address.description_en
                                    ?.replace('Novosibirsk, ', '')
                                    .replace('Voronezh, ', '')
                                    .replace('Novokuznetsk, ', '')
                                    .replace('Tashkent, ', '') ||
                                  address.description
                                    ?.replace('Новосибирск, ', '')
                                    .replace(', Алтайский край', '')
                                    .replace('Алтайский край, ', '')
                                    .replace('Воронеж, ', '')
                                    .replace('Новокузнецк, ', '')
                                    .replace('Ташкент, ', ''),
                          }}
                        />
                      </li>
                    ))}
                </div>
              ))}
            </ul>
          </div>
        </ModalComponent>
      )}
    </>
  );
}
export default ModalAddresses;
